import styled, { css } from 'styled-components';

const Checkmark = styled(({ className }) => (
  <span className="GiftBox-Offer-Checkmark">
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
    >
      <circle
        className="checkmark__circle"
        cx="26"
        cy="26"
        r="25"
        fill="none"
      />
      <path
        className="checkmark__check"
        fill="#fff"
        d="M14.8 8.2071C15.1906 7.81658 15.1906 7.18339 14.8 6.79288C14.4094 6.40238 13.7766 6.40236 13.3859 6.79288L8.94649 11.2322L7.00703 9.29287C6.61641 8.90236 5.9836 8.90235 5.59297 9.29287C5.20235 9.6834 5.20235 10.3166 5.59297 10.7071L8.23946 13.3536C8.63008 13.7441 9.26289 13.7441 9.65352 13.3536L14.8 8.2071Z"
      />
    </svg>
  </span>
)).attrs((props) => ({
  color: props.color || '#11A876', /* Note: The default color should be retrieved from tailwind configuration (primary-500) During APPS-5718 */
  curve: props.curve || 'cubic-bezier(0.650, 0.000, 0.450, 1.000)',
}))`
  border-radius: 50%;
  display: block;
  box-shadow: inset 0 0 0 30px ${(props) => props.color};


  ${(props) =>
    props.fadeCheckmarkAnimation &&
    css`
      animation: fadeInAndScaleCircle 0.3s ease-in-out;
    `}

  ${(props) =>
    props.scaleAnimation &&
    css`
        animation: scale-circle 0.3s ease-in-out 0.4s both;
    `}

  .checkmark__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke: ${(props) => props.color};
    fill: none;
    box-shadow: inset 0 0 0 30px ${(props) => props.color};

  }

  .checkmark__check {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;

    ${(props) =>
      props.fadeCheckmarkAnimation &&
      css`
        animation: fade-in-checkmark 0.5s ease-in;
      `}

  }

  @keyframes scale-circle {
    0%,
    100% {
      transform: none;
    }
    50% {
      transform: scale3d(1.1, 1.1, 1);
    }
  }

  @keyframes fade-in-checkmark {
    0%, 60% {
      opacity: 0;
    }
    100% {
      opacity: 100;
    }
  }

  @keyframes fadeInAndScaleCircle {
    0% {
      opacity: 0;
      transform: scale(0);
    }
    100% {
      opacity: 100;
      transform: scale(1);
    }
  }
`;

export default styled(Checkmark)`
  position: absolute;
  top: -7px;
  right: -8px;
  width: 20px;
  height: 20px;
`;

export const FullSizeCheckmark = styled(Checkmark)`
  width: 40px;
  height: 40px;
`;
